import React, { useState, useEffect } from 'react';
import { createContextHook } from 'use-context-hook';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from './authContext';
import campaignService from '../services/campaignService';
import { useLocation } from 'react-router-dom';

const context = {};

export const CampaignAnalyticsContext = createContextHook(context);

export function CampaignAnalyticsContextProvider({ children }) {
  const location = useLocation();
  const campaignId = location.state?.campaign_id;
  const [name, setName] = useState('');

  const { fetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
  }));

  const { campaign_analytics_data, campaign_analytics_loading } = campaignService.GetCampaignAnalytics(
    campaignId,
    fetch,
  );

  useEffect(() => {
    if (!campaign_analytics_data) return;

    const firstItem = campaign_analytics_data?.data?.[0] || {};
    const campaignName = firstItem?.campaign_name || '';
    if (campaignName) {
      setName(campaignName);
    }
  }, [campaign_analytics_data]);

  const value = {
    campaignAnalyticsData: campaign_analytics_data,
    campaignAnalyticsLoading: campaign_analytics_loading,
    campaignName: name,
  };

  return <CampaignAnalyticsContext.Provider value={value}>{children}</CampaignAnalyticsContext.Provider>;
}
